import { Button, CircularProgress, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "../../../api/config";
import { useStore } from "../../../store/store";

type RecalculateScoresConfirmDialogProps = {
	responseId: string;
	onClose: () => void;
};

export const RecalculateScoresConfirmDialog = ({ responseId, onClose }: RecalculateScoresConfirmDialogProps) => {
	const { notifications } = useStore();
	const queryClient = useQueryClient();
	const [isRecalculating, setIsRecalculating] = useState(false);

	const handleConfirm = async () => {
		setIsRecalculating(true);
		try {
			await api.post(`/instruments-forms/crm-responses/${responseId}/calculate`, { response_id: responseId });
			queryClient.invalidateQueries({
				predicate: (query) =>
					typeof query.queryKey[0] === "string" &&
					query.queryKey[0].startsWith(`responses_scores-items-parentId-${responseId}`),
			});
			notifications.setNotification({ isOpen: true, message: "Pontuações recalculadas com sucesso.", severity: "success" });
			onClose();
		} catch (error: any) {
			notifications.setNotification({
				isOpen: true,
				message: error?.response?.data?.errors?.[0]?.message || error?.response?.data?.errorMessage || "Erro ao recalcular as pontuações.",
				severity: "error",
			});
		} finally {
			setIsRecalculating(false);
		}
	};

	return (
		<>
			<DialogContent>
				<DialogContentText>
					Dependendo do instrumento, esta ação irá recalcular as pontuações brutas a partir das respostas e utilizar os novos valores para
					encontrar as normas da pontuação calculada.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button color="secondary" onClick={onClose} disabled={isRecalculating}>
					Cancelar
				</Button>
				<Button onClick={handleConfirm} disabled={isRecalculating}>
					{isRecalculating ? <CircularProgress color="inherit" size={24} /> : "Continuar"}
				</Button>
			</DialogActions>
		</>
	);
};
